/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useState, useEffect, useRef } from 'react';
// import { LoadScript, StandaloneSearchBox } from '@react-google-maps/api';
import clsx from 'clsx'
import { generatePopup } from '../../../../utils/popup';

// const libraries: ('places')[] = ['places']; //omitting due to eslint warning

// omitting due to eslint warning
interface AddressAutocompleteProps {
  onAddressSelect: (place: google.maps.places.PlaceResult) => void;
  valid?: boolean;
  dropdownPosition?: 'top' | 'bottom';
}

const styles = `
  .suggestion-item:hover {
    background-color: #f5f5f5;
  }
`;

const styleSheet = document.createElement('style');
styleSheet.textContent = styles;
document.head.appendChild(styleSheet);

const AddressAutocomplete = ({ onAddressSelect, valid, dropdownPosition = 'bottom' }) => {
  const [address, setAddress] = useState<string>('');
  const [suggestions, setSuggestions] = useState<google.maps.places.AutocompletePrediction[]>([]);
  const autocompleteServiceRef = useRef<google.maps.places.AutocompleteService | null>(null);
  const placesServiceRef = useRef<google.maps.places.PlacesService | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const [addressNotFound, setAddressNotFound] = useState(false)
  const [isManualInput, setIsManualInput] = useState(false)
  const [collapseManualInput, setCollapseManualInput] = useState(false)

  useEffect(() => {
    if (window.google && !autocompleteServiceRef.current) {
      autocompleteServiceRef.current = new google.maps.places.AutocompleteService();
    }
    if (window.google && !placesServiceRef.current) {
      placesServiceRef.current = new google.maps.places.PlacesService(document.createElement('div'));
    }
  }, [])

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    setAddressNotFound(0 < value.length && suggestions.length < 1)

    setAddress(value);
    if (value.length > 0 && autocompleteServiceRef.current) {
      autocompleteServiceRef.current.getPlacePredictions(
        {
          input: value,
          types: ['premise'],
          componentRestrictions: { country: 'us' }
        },
        (predictions, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK && predictions) {
            setSuggestions(predictions);
          } else {
            setSuggestions([]);
          }
        }
      );
    } else {
      setSuggestions([]);
    }
  }

  const handleSuggestionSelect = (placeId: string) => {
    if (placesServiceRef.current) {
      placesServiceRef.current.getDetails({ placeId }, (place, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && place) {
          setAddress(place.formatted_address || '');
          setSuggestions([]);
          onAddressSelect(place);
        }
      });
    }
  }

  // Manual Address Variables

  const [street, setStreet] = useState('')
  const [city, setCity]     = useState('')
  const [state, setState]   = useState('')
  const [zip, setZip]       = useState('')

  const allStates = [
    'AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL',
    'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH',
    'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM',
    'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC',
    'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY'
  ]

  const onUpdateShippingEstimate = () => {
    const isValidStreet = /\w+(\s\w+){1,}/.test(street)
    const hasEmptyFields = street === '' || city === '' || state === '' || zip === ''

    if(!isValidStreet) {
      generatePopup('error', 'Please add a valid street\nExample: 123 Evergreen Dr', 'bottom-center')
    } else if (hasEmptyFields) {
      generatePopup('error', 'Please add a street, city, state, and zip code', 'bottom-center')
    } else {
      setCollapseManualInput(true)
      onAddressSelect({
        address_components: [
          { long_name: street, short_name: '', types: ['street_number'] },
          { long_name: '', short_name: '', types: ['route'] }, //keep empty, street name+number are stored in "street"
          // { long_name: premise, short_name: '', types: ['premise'] },
          { long_name: city, short_name: '', types: ['locality'] },
          { long_name: '', short_name: state, types: ['administrative_area_level_1'] },
          { long_name: zip, short_name: '', types: ['postal_code'] },
        ]
      })
    }
  }

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      
      {isManualInput
        ? <>
            {collapseManualInput
            ? <>
                <button onClick={() => setCollapseManualInput(false)} className='btn btn-secondary w-100' style={{color: 'black'}}>
                  Edit Shipping Address
                </button>
              </>
            : <>
                <label style={{ position: 'relative', top: '10px' }} className='required fw-bold fs-8 mb-2'>Street Name & Number</label>
                <input value={street} placeholder="Street Name & Number" onChange={(e) => setStreet(e.target.value)}
                  type="text" style={{ width: '100%', padding: '10px' }} className={clsx('form-control form-control-solid mb-3 mb-lg-0 border', { 'is-invalid': !valid }, { 'is-valid': valid, })}
                />
                <label style={{ position: 'relative', top: '10px' }} className='required fw-bold fs-8 mb-2'>City</label>
                <input value={city} placeholder="City" onChange={(e) => setCity(e.target.value)}
                  type="text" style={{ width: '100%', padding: '10px' }} className={clsx('form-control form-control-solid mb-3 mb-lg-0 border', { 'is-invalid': !valid }, { 'is-valid': valid, })}
                />
                <label style={{ position: 'relative', top: '10px' }} className='required fw-bold fs-8 mb-2'>State</label>
                <select value={state} onChange={e => setState(e.target.value)} className={clsx('form-control form-control-solid mb-3 mb-lg-0 border', { 'is-invalid': !valid }, { 'is-valid': valid, })}>
                  {allStates.map((stateCode, key) => {
                    return <option value={stateCode} key={key}>{stateCode}</option>
                  })}
                </select>
                <label style={{ position: 'relative', top: '10px' }} className='required fw-bold fs-8 mb-2'>Zip Code</label>
                <input value={zip} placeholder="Zip Code" onChange={(e) => setZip(e.target.value)}
                  type="text" style={{ width: '100%', padding: '10px' }} className={clsx('form-control form-control-solid mb-3 mb-lg-0 border', { 'is-invalid': !valid }, { 'is-valid': valid, })}
                />
                <button onClick={onUpdateShippingEstimate} className='btn btn-secondary w-100' style={{color: 'black'}}>
                  Update Shipping Estimate
                </button>
              </>
            }
          </>
        : <>
            <label style={{ position: 'relative', top: '10px' }} className='required fw-bold fs-8 mb-2'>Shipping Address</label>
            <input
              type="text"
              placeholder="Enter your address"
              ref={inputRef}
              value={address}
              onChange={handleInputChange}
              style={{ width: '100%', padding: '10px' }}
              className={clsx(
                'form-control form-control-solid mb-3 mb-lg-0 border',
                { 'is-invalid': !valid }, { 'is-valid': valid, }
              )}
            />

            {suggestions.length > 0 && (
              <ul style={{
                position: 'absolute',
                ...(dropdownPosition === 'top'
                  ? { bottom: '100%' }
                  : { top: '100%' }),
                left: 0,
                right: 0,
                backgroundColor: 'white',
                border: '1px solid #ccc',
                borderRadius: '4px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                zIndex: 1000,
                listStyleType: 'none',
                margin: 0,
                padding: 0,
                maxHeight: '300px',
                overflowY: 'auto'
              }}>
                {suggestions.map((suggestion) => (
                  <li
                    key={suggestion.place_id}
                    onClick={() => handleSuggestionSelect(suggestion.place_id)}
                    className="suggestion-item"
                    style={{ padding: '10px', cursor: 'pointer', transition: 'background-color 0.2s' }}
                  >
                    {suggestion.description}
                  </li>
                ))}
                <li onClick={() => setIsManualInput(true)} className="suggestion-item" style={{ padding: '10px', cursor: 'pointer', transition: 'background-color 0.2s' }} key={0}>
                  <b>My Address is not in the list</b>
                </li>
              </ul>
            )}
          </>
      }
    </div>
  );
};

export default AddressAutocomplete;
